




// import React, { useEffect, useState } from "react";
// import JSZip from "jszip";
// import { saveAs } from "file-saver";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";
// import { FaDownload } from "react-icons/fa";
// const Manageprojects = ({ admin }) => {
//   const [projects, setProjects] = useState([]);
//   const [payData, setPaydata] = useState([]);
//   const [show, setShow] = useState(false);
//   const [remark, setRemark] = useState("");
//   const [selectedId, setSelectedId] = useState(null);
// const [showPayment, setShowPayment] = useState(false);
// const [selectedProject, setSelectedProject] = useState(null);
// const [amount, setAmount] = useState("");
// const [paymentDate, setPaymentDate] = useState("");
// const [totalAmount, setTotalAmount] = useState(0);
//   const [viewData, setViewData] = useState(null);
//   const [hoveredRow, setHoveredRow] = useState(null);
//   const [showPayHistory, setShowPayHistory] = useState(false);
// const [reportFile, setReportFile] = useState(null);
// const [showVerify, setShowVerify] = useState(false);
// const [verifyId, setVerifyId] = useState(null);

// const navigate = useNavigate();

//   const fetchData = async () => {
//     const res = await axios.get("https://api.d2associates.in//projects");
//     const data = res.data;

// console.log(data);

//     const filteredData =
//       admin.role === "admin"
//         ? data.filter((project) => project.status === "reviewed" || project.status === "completed")
//         : data.filter((project) => project.status === "assigned");

//     setProjects(filteredData);
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);
// const downloadAllImages = async (images) => {

//   if (!images || images.length === 0) {
//     toast.error("No Images Found");
//     return;
//   }

//   try {

//     const zip = new JSZip();

//     const folder = zip.folder("site-images");

// for (let i = 0; i < images.length; i++) {

//   try {

//     const img = images[i];

//     console.log("Downloading:", img);

//     const response = await fetch(
//       `https://api.d2associates.in//dUploads/${img}`,
//       {
//         mode: "cors",
//         cache: "no-cache",
//       }
//     );

//     if (!response.ok) {

//       console.log("Failed:", img);

//       continue;

//     }

//     const blob = await response.blob();

//     // folder.file(img, blob);
//     folder.file(`${i + 1}-${img}`, blob);

//     console.log("Added:", img);

//   } catch (err) {

//     console.log(
//       "Error downloading image:",
//       images[i],
//       err
//     );

//   }

// }

//     const zipBlob = await zip.generateAsync({
//       type: "blob",
//     });

//     saveAs(zipBlob, "site-images.zip");

//     toast.success("Images Downloaded");

//   } catch (err) {

//     console.log(err);

//     toast.error("Download Failed");

//   }

// };

// //   const handleReport = async () => {
// //   if (!reportFile) {
// //     toast.error("Please select file");
// //     return;
// //   }

// //   const formData = new FormData();
// //   formData.append("report", reportFile);

// //   try {
// //     await axios.put(
// //       `https://api.d2associates.in/daso/project/report/${selectedId}`,
// //       formData,
// //       {
// //         headers: {
// //           "Content-Type": "multipart/form-data",
// //         },
// //       }
// //     );

// //     toast.success("Report Uploaded");

// //     setShow(false);
// //     setReportFile(null);
// //     fetchData();
// //   } catch (err) {
// //     console.error(err);
// //     toast.error("Upload failed");
// //   }
// // };
//   const handlePaymentSubmit = async () => {
//   if (!amount) {
//     toast.error("Enter amount");
//     return;
//   }

//   try {
//     await axios.post("https://api.d2associates.in//add-payment", {
//       project_id: selectedProject.id,
//  amount: Number(amount),
// date_time: paymentDate || null,
//     });

//     toast.success("Payment Added");

//     setShowPayment(false);
//     setAmount("");
//     setPaymentDate("");
//   } catch (err) {
//     console.error(err);
//     toast.error("Error adding payment");
//   }
// };

//   // const handleReview = async () => {
//   //   if (!remark) {
//   //  toast.error("Enter remark");
//   //     return;
//   //   }

//   //   await axios.put(
//   //     `https://api.d2associates.in/daso/project/review/${selectedId}`,
//   //     { remark }
//   //   );

//   // toast.success("Reviewed Successfully");
//   //   setShow(false);
//   //   setRemark("");
//   //   setSelectedId(null);
//   //   fetchData();
//   // };
// const handleReview = async () => {
//   if (!remark) {
//     toast.error("Enter remark");
//     return;
//   }

//   try {
//     // remark update
//     await axios.put(
//       `https://api.d2associates.in//project/review/${selectedId}`,
//       { remark }
//     );

  
//     if (reportFile) {
//       const formData = new FormData();
//       formData.append("report", reportFile);

//       await axios.put(
//         `https://api.d2associates.in//project/report/${selectedId}`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//     }

//     toast.success("Reviewed Successfully");

//     setShow(false);
//     setRemark("");
//     setReportFile(null);
//     setSelectedId(null);

//     fetchData();
//   } catch (err) {
//     console.error(err);
//     toast.error("Something went wrong");
//   }
// };
//   return (
//     <div style={page}>
//       <h2 style={heading}>Manage Projects</h2>

//       <div style={card}>
//         <div style={tableWrapper}>
//           <table style={table}>
//             <thead style={thead}>
//               <tr>
//                 {["#", "Project Name", "Bank Name", "Branch", "Assigned To", "Status","Documents", "Remark", "Date", "Action"].map((h, i) => (
//                   <th key={i} style={th}>{h}</th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {projects.map((p, index) => (
                
                
//                 <tr
//                   key={p.id}
//                   onMouseEnter={() => setHoveredRow(p.id)}
//                   onMouseLeave={() => setHoveredRow(null)}
//                   style={{
//                     ...tr,
//                     backgroundColor: hoveredRow === p.id ? "#D4C2BB" : "#fff",
//                   }}
//                 >
//                   <td style={td}>{index + 1}</td>

//                   <td style={td}>
//                     <div style={nameCell}>
//                       <div style={avatar}>
//                         {p.project_name.charAt(0).toUpperCase()}
//                       </div>
//                       {p.project_name}
//                     </div>
//                   </td>

//                   <td style={td}>{p.bank_name}</td>
//                   <td style={td}>{p.branch}</td>
//                   <td style={td}>{p.assigned_name || "Not Assigned"}</td>

//                   <td style={td}>
//                     <span style={{
//                       ...status,
//                       background:
//                         p.status === "reviewed"
//                           ? "#28a745"
//                           : p.status === "assigned"
//                           ? "#007bff"
//                           : "#ffc107",
//                     }}>
//                       {p.status}
//                     </span>
//                   </td>
                 
//                   <td style={td}>
//   {p.report ? (
//     <>
//       {p.report.match(/\.(jpg|jpeg|png|gif|webp)$/i) ? (
//         <img
//           src={`https://api.d2associates.in//dUploads/${p.report}`}
//           alt="report"
//           style={{
//             width: "60px",
//             height: "60px",
//             objectFit: "cover",
//             borderRadius: "6px",
//             cursor: "pointer",
//           }}
//           onClick={() =>
//             window.open(
//               `https://api.d2associates.in//dUploads/${p.report}`,
//               "_blank"
//             )
//           }
//         />
//       ) : (
//         <a
//           href={`https://api.d2associates.in//dUploads/${p.report}`}
//           target="_blank"
//           rel="noreferrer"
//           style={{ color: "#007bff", textDecoration: "none" }}
//         >
//           View 
//         </a>
//       )}
//     </>
//   ) : (
//     "No Document"
//   )}

// </td>
          

//                   <td style={td}>{p.remark || "-"}</td>
//                   <td style={td}>{new Date(p.created_at).toLocaleDateString()}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "8px" }}>
//                       <button
//                         style={viewBtn}
//                         onClick={async () => {
//                           const res = await axios.get(
//                             `https://api.d2associates.in//property/project/${p.id}`
//                           );
//                           setViewData(res.data);
//                         }}
//                       >
//                         View
//                       </button>
//                       {admin?.role === "admin" && (
//                    <button
//   style={viewBtn}
//   onClick={async () => {
//       const res = await axios.get(
//                             `https://api.d2associates.in//property/project/${p.id}`
//                           );


//                            const payRes = await axios.get(
//                             `https://api.d2associates.in//get-project-payment/${p.id}`
//                           );
// // console.log(payRes.data);

// setPaydata(payRes.data);
//     setSelectedProject(p);
//         setTotalAmount(res.data.purchase_amount || 0);
//           setShowPayment(true);

//   }}
// >
//   Received
// </button>
//                       )}
//                       {admin?.role === "reviewer" && p.status !== "reviewed" && (
//   <button
//     style={btn}
//     onClick={() => {
//       setSelectedId(p.id);
//       setShow(true);
//     }}
//   >
//     Remark
//   </button>
// )}

//                       {/* {p.status !== "reviewed" && (
//                         <button
//                           style={btn}
//                           onClick={() => {
//                             setSelectedId(p.id);
//                             setShow(true);
//                           }}
//                         >
//                           Remark
//                         </button>
                        

                        
//                       )} */}
// {/* {admin?.role === "admin" && (
//   <button
//     style={btn}
//     onClick={() => {
//       setVerifyId(p.id);
//       setShowVerify(true);
//     }}
//   >
//     verify
//   </button> */}
//   {/* {admin?.role === "admin" && (
//   p.status === "completed" ? (
//     <button
//       style={btn}
//       onClick={() => {
//         // invoice button action
//       }}
//     >
//       Invoice
//     </button>
//   ) : (
//     <button
//       style={btn}
//       onClick={() => {
//         setVerifyId(p.id);
//         setShowVerify(true);
//       }}
//     >
//       Verify
//     </button>
//   )
// )} */}
// {admin?.role === "admin" && (
//   p.status === "completed" ? (
//     <button
//       style={btn}
//       onClick={() => {
//         navigate("/admin/invoice-form", {
//           state: { data: p }
//         });
//       }}
//     >
//       Invoice
//     </button>
//   ) : (
//     <button
//       style={btn}
//       onClick={() => {
//         setVerifyId(p.id);
//         setShowVerify(true);
//       }}
//     >
//       Verify
//     </button>
//   )
// )}        
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//       {showVerify && (
//   <div style={overlay}>
//     <div style={modal}>
//       <button style={closeBtn} onClick={() => setShowVerify(false)}>
//         ×
//       </button>

//       <h4>Verify Project</h4>

//       <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        
//         <button
//           style={{ ...submitBtn, width: "50%", background: "#D4c2BB",color:"#6c4636" }}
//           onClick={async () => {
//             try {
//               await axios.put(
//                 `https://api.d2associates.in//project/resubmit/${verifyId}`
//               );

//               toast.success("Resubmitted");
//               setShowVerify(false);
//               fetchData();
//             } catch (err) {
//               toast.error("Error in resubmit");
//             }
//           }}
//         >
//           Resubmit
//         </button>

//         <button
//           style={{ ...submitBtn, width: "50%", background: "#6c4636" }}
//           onClick={async () => {
//             try {
//               await axios.put(
//                 `https://api.d2associates.in//project/complete/${verifyId}`
//               );

//               toast.success("Completed");
//               setShowVerify(false);
//               fetchData();
//             } catch (err) {
//               toast.error("Error in complete");
//             }
//           }}
//         >
//           Complete
//         </button>

//       </div>
//     </div>
//   </div>
// )}
//       {showPayment && (
//   <div style={overlay}>
//     <div style={modal}>
//       <button style={closeBtn} onClick={() => setShowPayment(false)}>×</button>

//       <h4>Receive Payment</h4>
// <br />
//       <p><b>Project:</b> {selectedProject?.project_name}</p>
//       <p><b>Total Amount:</b> ₹ {totalAmount}</p>
// <p>
//   <b>Total Paid:</b> ₹{" "}
//   {payData.reduce((total, item) => total + Number(item.amount), 0)}
// </p>   

// <br />
// <p className="text-danger">
//   <b>Pending:</b> ₹{" "}
//   {totalAmount - payData.reduce((total, item) => total + Number(item.amount), 0)}
// </p>
//       <input
//         type="number"
//         placeholder="Enter Amount"
//         value={amount}
//         onChange={(e) => setAmount(e.target.value)}
//         style={{ width: "100%", marginTop: "10px", padding: "8px" }}
//       />

//       <input
//         type="datetime-local"
//         value={paymentDate}
//         onChange={(e) => setPaymentDate(e.target.value)}
//         style={{ width: "100%", marginTop: "10px", padding: "8px" }}
//       />

//       <button className="mt-4 py-2" style={submitBtn} onClick={handlePaymentSubmit}>
//         Submit Now
//       </button>

//              <button className="btn btn-secondary w-100 mt-3" onClick={() => setShowPayHistory(true)}>
//         View Report
//       </button>

//     </div>
//   </div>
// )}



// {showPayHistory && (
//    <div style={overlay}>
//           <div style={modal}>

//  <button style={closeBtn} onClick={() => setShowPayHistory(false)}>×</button>

//       <h4>Payment Report</h4>

// <br />
// <div className="table-responsive">
// <table className="w-100">

// <thead className="bg-dark text-light">
// <th className="p-2">S No</th>
// <th className="p-2">Date</th>
// <th className="p-2">Amount</th>
// </thead>

// <tbody>
//   {payData.map((item, index) => (
//     <tr key={index}>
//       <td className="px-2 py-3 border-bottom">{index + 1}</td>
//       <td className="px-2 py-3 border-bottom">₹ {item.amount}</td>
// <td className="px-2 py-3 border-bottom">
//   {new Date(item.date_time).toLocaleString("en-IN", {
    
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//   })}
// </td>    </tr>
//   ))}
// </tbody>


// </table>

//   </div>


//           </div>
//           </div>
// )}

//       {show && (
//         <div style={overlay}>
//           <div style={modal}>
//             <button style={closeBtn} onClick={() => setShow(false)}>×</button>
//             <h4>Add Remark</h4>

//             <textarea
//               style={textarea}
//               value={remark}
//               onChange={(e) => setRemark(e.target.value)}
//             />
//             <input
//   type="file"
//   accept=".pdf,.doc,.docx,.jpg,.png"
//   onChange={(e) => setReportFile(e.target.files[0])}
//   style={{ marginTop: "10px" }}
// />

//            {/* <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//   <button style={submitBtn} onClick={handleReview}>
//     Submit
//   </button>

//   <button style={submitBtn} onClick={handleReport}>
//     Report
//   </button>
// </div> */}

// <div style={{ marginTop: "10px" }}>
//   <button style={submitBtn} onClick={handleReview}>
//     Submit
//   </button>
// </div>
//           </div>
//         </div>
//       )}
//       {viewData && (
//   <div style={detailCard}>

//     <div className="d-flex justify-content-between">
//     <h3 style={modalTitle}>Property Inspection Full Report</h3>
//     <span className="fs-3" onClick={() => setViewData(false)}>x</span>
// </div>

//     <Section title="Owner Details">
//       <p>Name: {viewData.owner_name}</p>
//       <p>Father: {viewData.owner_father}</p>
//       <p>Contact: {viewData.owner_contact}</p>
//       <p>Address: {viewData.owner_address}</p>
//     </Section>


//     <Section title="Borrower Details">
//       <p>Name: {viewData.borrower_name}</p>
//       <p>Father: {viewData.borrower_father}</p>
//       <p>Contact: {viewData.borrower_contact}</p>
//       <p>Address: {viewData.borrower_address}</p>
//     </Section>


//     <Section title="Location">
//       <p>Latitude: {viewData.latitude}</p>
//       <p>Longitude: {viewData.longitude}</p>
//     </Section>


//     <Section title="Property Details">
//       <p>Sale Deed: {viewData.sale_deed_no}</p>
//       <p>Registration: {viewData.registration_date}</p>
//       <p>Amount: {viewData.purchase_amount}</p>
//       <p>Locality Price: {viewData.locality_price}</p>
//       <p>Comment: {viewData.property_comment}</p>
//     </Section>


//     <Section title="Land Details">
//       <p>Khata: {viewData.khata_no}</p>
//       <p>Plot: {viewData.plot_no}</p>
//       <p>Village: {viewData.village}</p>
//       <p>Tahasil: {viewData.tahasil}</p>
//       <p>Thana: {viewData.thana}</p>
//       <p>District: {viewData.district}</p>
//       <p>Postal: {viewData.postal_address}</p>
//     </Section>


//     <Section title="Area">
//       <p>Acre: {viewData.land_acre}</p>
//       <p>Sqft: {viewData.land_sqft}</p>
//     </Section>


//     <Section title="Boundary">
//       <p>East: {viewData.east}</p>
//       <p>West: {viewData.west}</p>
//       <p>North: {viewData.north}</p>
//       <p>South: {viewData.south}</p>
//     </Section>


//     <Section title="Road">
//       <p>Width: {viewData.road_width}</p>
//       <p>Type: {viewData.road_type}</p>
//       <p>Sewerage: {viewData.sewerage ? "Yes" : "No"}</p>
//       <p>Electricity: {viewData.electricity ? "Yes" : "No"}</p>
//     </Section>


//     <Section title="Building">
//       <p>Floors: {viewData.floors}</p>
//       <p>Structure: {viewData.structure_type}</p>
//       <p>Flooring: {viewData.flooring}</p>
//       <p>Interior: {viewData.interior}</p>
//       <p>Design: {viewData.designing}</p>
//       <p>Builtup: {viewData.builtup_area}</p>
//       <p>Year: {viewData.construction_year}</p>
//     </Section>


//     <Section title="Approval">
//       <p>Status: {viewData.approval_status}</p>
//       <p>Authority: {viewData.approving_authority}</p>
//       <p>Letter: {viewData.approval_letter}</p>
//       <p>Date: {viewData.approval_date}</p>
//       <p>FAR: {viewData.far}</p>
//     </Section>

  
//     <Section title="Nearby">
//       <p>Landmark: {viewData.landmark}</p>
//       <p>School: {viewData.school_distance}</p>
//       <p>Hospital: {viewData.hospital_distance}</p>
//       <p>Park: {viewData.park_distance}</p>
//     </Section>

   
//     <Section title="Final Remark">
//       <p>{viewData.remark}</p>
//     </Section>

// {/*   
//     <Section title="Site Images">
//   <div style={imageWrap}>
//     {(() => {
//       if (!viewData.site_images) return <span>No Images</span>;

//       let imgs = [];

//       try {
//         imgs = JSON.parse(viewData.site_images);
//       } catch {
//         console.log("Bad JSON:", viewData.site_images);
//         return <span>Invalid Image Data</span>;
//       }

//       if (!Array.isArray(imgs)) return <span>No Images</span>;

//       return imgs.length > 0 ? (
//         imgs.map((img, i) => (
//           <img
//             key={i}
//             src={`https://api.d2associates.in//dUploads/${img}`}
//             style={imageStyle}
//             onError={(e) => {
//               console.log("Image :", img);
//               e.target.style.display = "none";
//             }}
//           />
//         ))
//       ) : (
//         <span>No Images</span>
//       );
//     })()}
//   </div>
// </Section> */}
// <Section title="Site Images">

//   {(() => {

//     if (!viewData.site_images)
//       return <span>No Images</span>;

//     let imgs = [];

//     try {

//       imgs = JSON.parse(
//         viewData.site_images
//       );

//     } catch {

//       return (
//         <span>Invalid Image Data</span>
//       );

//     }

//     if (!Array.isArray(imgs))
//       return <span>No Images</span>;

//     return (
//       <>
//       <button
//   style={{
//     ...btn,
//     marginBottom: "10px",
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//   }}
//   onClick={() => downloadAllImages(imgs)}
// >
//   <FaDownload />
//   Download All Images
// </button>
// {/* 
//         <button
//           style={{
//             ...btn,
//             marginBottom: "10px",
//           }}

//           onClick={() =>
//             downloadAllImages(imgs)
//           }
//         >
//           Download All Images
//         </button> */}

//         <div style={imageWrap}>

//           {imgs.map((img, i) => (

//             <img
//               key={i}

//               src={`https://api.d2associates.in//dUploads/${img}`}

//               style={imageStyle}

//               onError={(e) => {
//                 e.target.style.display =
//                   "none";
//               }}
//             />

//           ))}

//         </div>

//       </>
//     );

//   })()}

// </Section>

//     <Section title="Documents">
//   {(() => {
//     if (!viewData.documents) return <span>No Documents</span>;

//     let docs = [];

//     try {
//       docs = JSON.parse(viewData.documents);
//     } catch {
//       return <span>Invalid Document Data</span>;
//     }

//     if (!Array.isArray(docs)) return <span>No Documents</span>;

//     return docs.length > 0 ? (
//       docs.map((doc, i) => (
//         <a
//           key={i}
//           href={`https://api.d2associates.in//dUploads/${doc}`}
//           target="_blank"
//           rel="noreferrer"
//           style={docLink}
//         >
//            View Document {i + 1}
//         </a>
//       ))
//     ) : (
//       <span>No Documents</span>
//     );
//   })()}
// </Section>
  
//   </div>
// )}
// <ToastContainer position="top-center" autoClose={2000} />

//       </div>
//   );
// };

// export default Manageprojects;

// const page = { padding: "20px", background: "#f5f7fb", minHeight: "100vh" };
// const heading = { marginBottom: "15px", color: "#333" };
// const card = { background: "#fff", borderRadius: "10px", padding: "15px" };
// // const tableWrapper = { width: "100%", overflowX: "auto" };
// const tableWrapper = { 
//   width: "100%", 
//   overflowX: "auto",
//   WebkitOverflowScrolling: "touch"
// };
// const table = { width: "100%", borderCollapse: "collapse" };
// const thead = { background: "#D4C2BB" };
// const th = { padding: "12px" };
// const tr = { borderBottom: "1px solid #eee" };
// const td = { padding: "10px" };

// const nameCell = { display: "flex", gap: "10px" };
// // const avatar = {
// //   width: "30px", height: "30px", borderRadius: "50%",
// //   background: "#D4C2BB", display: "flex", alignItems: "center", justifyContent: "center"
// // };

// const avatar = {
//   width: "30px",
//   height: "30px",
//   borderRadius: "50%",
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   fontWeight: "bold",
// };


// const status = {
//   padding: "4px 8px", borderRadius: "6px", color: "#fff", fontSize: "12px"
// };

// const btn = { padding: "6px 12px", background: "#6c4636", color: "#fff", border: "none", borderRadius: "6px" };
// const viewBtn = { padding: "6px 14px", background: "#D4c2BB", color: "#7D4B3c", border: "none", borderRadius: "6px" };

// const overlay = {
//   position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
//   background: "rgba(0,0,0,0.3)", display: "flex", justifyContent: "center", alignItems: "center"
// };

// //  const modal = { 
// //   background: "#fff", 
// //   padding: "20px", 
// //   borderRadius: "10px", 
// //   width: "520px",
// //   position: "relative"  
// // };
// const modal = { 
//   background: "#fff", 
//   padding: "20px", 
//   borderRadius: "10px", 
//   width: "90%",
//   maxWidth: "520px",
//   maxHeight: "90vh",
//   overflowY: "auto",
//   position: "relative"  
// };
// // const closeBtn = { position: "absolute", right: "10px", top: "5px", border: "none", background: "transparent", cursor: "pointer" };
// const closeBtn = {
//   position: "absolute",
//   right: "10px",
//   top: "10px",
//   border: "none",
//   background: "#D4C2BB",
//   color: "#000",
//   fontSize: "18px",
//   width: "28px",
//   height: "28px",
//   borderRadius: "50%",
//   cursor: "pointer",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center"
// };

// const textarea = { width: "100%", height: "80px", marginTop: "10px" };

// const submitBtn = {
//   marginTop: "10px", padding: "6px 12px", background: "#6c4636",
//   color: "#fff", border: "none", borderRadius: "6px", width: "20%"
// };


// const detailCard = {
//   background: "#fff",
//   marginTop: "20px",
//   padding: "20px",
//   borderRadius: "10px",
//   boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
// };

// const modalTitle = { fontSize: "18px", fontWeight: "600" };

// const grid = {
//   display: "grid",
//   gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//   gap: "10px",
//   marginTop: "10px"
// };

// const detailBox = {
//   background: "#f9f9f9",
//   padding: "10px",
//   borderRadius: "6px",
//   display: "flex",
//   justifyContent: "space-between"
// };

// const imageWrap = {
//   display: "flex",
//   gap: "10px",
//   flexWrap: "wrap",
//   marginTop: "10px"
// };

// const imageStyle = {
//   width: "100px",
//   height: "80px",
//   objectFit: "cover",
//   borderRadius: "6px"
// };

// const docLink = {
//   display: "block",
//   color: "#007bff",
//   marginTop: "5px"
// };
// const Section = ({ title, children }) => (
//   <div style={{
//     marginTop: "15px",
//     padding: "10px",
//     background: "#f9f9f9",
//     borderRadius: "6px"
//   }}>
//     <h4 style={{ marginBottom: "5px" }}>{title}</h4>
//     {children}
//   </div>
// );







import React, { useEffect, useState } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
const Manageprojects = ({ admin }) => {
  const [projects, setProjects] = useState([]);
  const [payData, setPaydata] = useState([]);
  const [show, setShow] = useState(false);
  const [remark, setRemark] = useState("");
  const [selectedId, setSelectedId] = useState(null);
const [showPayment, setShowPayment] = useState(false);
const [selectedProject, setSelectedProject] = useState(null);
const [amount, setAmount] = useState("");
const [paymentDate, setPaymentDate] = useState("");
const [totalAmount, setTotalAmount] = useState(0);
  const [viewData, setViewData] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [showPayHistory, setShowPayHistory] = useState(false);
const [reportFile, setReportFile] = useState(null);
const [showVerify, setShowVerify] = useState(false);
const [verifyId, setVerifyId] = useState(null);
const [showRevert, setShowRevert] =
  useState(false);

const [revertRemark, setRevertRemark] =
  useState("");

const [revertId, setRevertId] =
  useState(null);

const navigate = useNavigate();

  const fetchData = async () => {
    const res = await axios.get("https://api.d2associates.in/projects");
    const data = res.data;

// console.log(data);

    const filteredData =
      admin.role === "admin"
        ? data.filter((project) => project.status === "reviewed" || project.status === "completed")
        : data.filter((project) => project.status === "assigned");

    setProjects(filteredData);
  };

  useEffect(() => {
    fetchData();
  }, []);
const downloadAllImages = async (images) => {

  if (!images || images.length === 0) {
    toast.error("No Images Found");
    return;
  }

  try {

    const zip = new JSZip();

    const folder = zip.folder("site-images");

for (let i = 0; i < images.length; i++) {

  try {

    const img = images[i];

    console.log("Downloading:", img);

    // const response = await fetch(
    //   `https://api.siddhabhairabistore.com/dUploads/${img}`,
    //   {
    //     mode: "cors",
    //     cache: "no-cache",
    //   }
    // );
    const response = await fetch(
  `https://api.d2associates.in/dUploads/${encodeURIComponent(img)}`,
  {
    mode: "cors",
    cache: "no-cache",
  }
);

    if (!response.ok) {

      console.log("Failed:", img);

      continue;

    }

    const blob = await response.blob();

    // folder.file(img, blob);
    folder.file(`${i + 1}-${img}`, blob);

    console.log("Added:", img);

  } catch (err) {

    console.log(
      "Error downloading image:",
      images[i],
      err
    );

  }

}

    const zipBlob = await zip.generateAsync({
      type: "blob",
    });

    saveAs(zipBlob, "site-images.zip");

    toast.success("Images Downloaded");

  } catch (err) {

    console.log(err);

    toast.error("Download Failed");

  }

};

//   const handleReport = async () => {
//   if (!reportFile) {
//     toast.error("Please select file");
//     return;
//   }

//   const formData = new FormData();
//   formData.append("report", reportFile);

//   try {
//     await axios.put(
//       `https://api.d2associates.in/daso/project/report/${selectedId}`,
//       formData,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );

//     toast.success("Report Uploaded");

//     setShow(false);
//     setReportFile(null);
//     fetchData();
//   } catch (err) {
//     console.error(err);
//     toast.error("Upload failed");
//   }
// };
  const handlePaymentSubmit = async () => {
  if (!amount) {
    toast.error("Enter amount");
    return;
  }

  try {
    await axios.post("https://api.d2associates.in/add-payment", {
      project_id: selectedProject.id,
 amount: Number(amount),
date_time: paymentDate || null,
    });

    toast.success("Payment Added");

    setShowPayment(false);
    setAmount("");
    setPaymentDate("");
  } catch (err) {
    console.error(err);
    toast.error("Error adding payment");
  }
};

  // const handleReview = async () => {
  //   if (!remark) {
  //  toast.error("Enter remark");
  //     return;
  //   }

  //   await axios.put(
  //     `https://api.d2associates.in/daso/project/review/${selectedId}`,
  //     { remark }
  //   );

  // toast.success("Reviewed Successfully");
  //   setShow(false);
  //   setRemark("");
  //   setSelectedId(null);
  //   fetchData();
  // };
const handleReview = async () => {
  if (!remark) {
    toast.error("Enter remark");
    return;
  }

  try {
    // remark update
    await axios.put(
      `https://api.d2associates.in/project/review/${selectedId}`,
      { remark }
    );

  
    if (reportFile) {
      const formData = new FormData();
      formData.append("report", reportFile);

      await axios.put(
        `https://api.d2associates.in/project/report/${selectedId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    toast.success("Reviewed Successfully");

    setShow(false);
    setRemark("");
    setReportFile(null);
    setSelectedId(null);

    fetchData();
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  }
};
  return (
    <div style={page}>
      <h2 style={heading}>Manage Projects</h2>

      <div style={card}>
        <div style={tableWrapper}>
          <table style={table}>
            <thead style={thead}>
              <tr>
                {["#", "Project Name", "Bank Name", "Branch", "Assigned To", "Status","Documents", "Remark", "Date", "Action"].map((h, i) => (
                  <th key={i} style={th}>{h}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {projects.map((p, index) => (
                
                
                <tr
                  // key={p.id}
                    key={`${p.id}-${index}`}
                  onMouseEnter={() => setHoveredRow(p.id)}
                  onMouseLeave={() => setHoveredRow(null)}
                  style={{
                    ...tr,
                    backgroundColor: hoveredRow === p.id ? "#D4C2BB" : "#fff",
                  }}
                >
                  <td style={td}>{index + 1}</td>

                  <td style={td}>
                    <div style={nameCell}>
                      <div style={avatar}>
                        {p.project_name.charAt(0).toUpperCase()}
                      </div>
                      {p.project_name}
                    </div>
                  </td>

                  <td style={td}>{p.bank_name}</td>
                  <td style={td}>{p.branch}</td>
                  <td style={td}>{p.assigned_name || "Not Assigned"}</td>

                  <td style={td}>
                    <span style={{
                      ...status,
                      background:
                        p.status === "reviewed"
                          ? "#28a745"
                          : p.status === "assigned"
                          ? "#007bff"
                          : "#ffc107",
                    }}>
                      {p.status}
                    </span>
                  </td>
                 
                  <td style={td}>
  {p.report ? (
    <>
      {p.report.match(/\.(jpg|jpeg|png|gif|webp)$/i) ? (
        <img
          src={`https://api.d2associates.in/dUploads/${p.report}`}
          alt="report"
          style={{
            width: "60px",
            height: "60px",
            objectFit: "cover",
            borderRadius: "6px",
            cursor: "pointer",
          }}
          onClick={() =>
            window.open(
              `https://api.d2associates.in/dUploads/${p.report}`,
              "_blank"
            )
          }
        />
      ) : (
        <a
          href={`https://api.d2associates.in/dUploads/${p.report}`}
          target="_blank"
          rel="noreferrer"
          style={{ color: "#007bff", textDecoration: "none" }}
        >
          View 
        </a>
      )}
    </>
  ) : (
    "No Document"
  )}

</td>
          

                  <td style={td}>{p.remark || "-"}</td>
                  <td style={td}>{new Date(p.created_at).toLocaleDateString()}</td>

                  <td style={td}>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        style={viewBtn}
                        onClick={async () => {
                          const res = await axios.get(
                            `https://api.d2associates.in/property/project/${p.id}`
                          );
                          setViewData(res.data);
                        }}
                      >
                        View
                      </button>
                      {admin?.role === "admin" && (
                   <button
  style={viewBtn}
  onClick={async () => {
      const res = await axios.get(
                            `https://api.d2associates.in/property/project/${p.id}`
                          );


                           const payRes = await axios.get(
                            `https://api.d2associates.in/get-project-payment/${p.id}`
                          );
// console.log(payRes.data);

setPaydata(payRes.data);
    setSelectedProject(p);
        setTotalAmount(res.data.purchase_amount || 0);
          setShowPayment(true);

  }}
>
  Received
</button>
                      )}
                      {/* {admin?.role === "reviewer" && p.status !== "reviewed" && (
  <button
    style={btn}
    onClick={() => {
      setSelectedId(p.id);
      setShow(true);
    }}
  >
    Remark
  </button>
)} */}

{admin?.role === "reviewer" && (
  <>
  
    {/* REVIEW BUTTON */}
    <button
      style={btn}
      onClick={() => {
        setSelectedId(p.id);
        setShow(true);
      }}
    >
      Review
    </button>

    {/* REVERT BUTTON */}
    <button
      style={{
        ...btn,
        background: "red",
      }}
//       onClick={async () => {

//         const revertRemark =
//           prompt("Enter Revert Remark");

//         if (!revertRemark) return;

//         try {

//      await axios.put(
//   `https://api.d2associates.in//api/property/revert/${p.id}`,
//   {
//     editremark: revertRemark
//   }
// );

//           toast.success("Reverted Successfully");

//           fetchData();

//         } catch (err) {

//           console.log(err);

//           toast.error("Error");

//         }

//       }}
onClick={() => {

  setRevertId(p.id);

  setShowRevert(true);

}}
    >
      Revert
    </button>

  </>
)}
{showRevert && (

  <div style={overlay}>

    <div style={modal}>

      <button
        style={closeBtn}
        onClick={() =>
          setShowRevert(false)
        }
      >
        ×
      </button>

      <h4>Revert Project</h4>

      <textarea
        placeholder="Enter Revert Remark"
        value={revertRemark}
        onChange={(e) =>
          setRevertRemark(
            e.target.value
          )
        }
        style={textarea}
      />

      <button
        style={submitBtn}
        onClick={async () => {

          if (!revertRemark) {

            toast.error(
              "Enter Remark"
            );

            return;

          }

          try {

            await axios.put(
              `https://api.d2associates.in/api/property/revert/${revertId}`,
              {
                editremark:
                  revertRemark
              }
            );

            toast.success(
              "Reverted Successfully"
            );

            setShowRevert(false);

            setRevertRemark("");

            setRevertId(null);

            fetchData();

          } catch (err) {

            console.log(err);

            toast.error("Error");

          }

        }}
      >
        Submit
      </button>

    </div>

  </div>

)}

                      {/* {p.status !== "reviewed" && (
                        <button
                          style={btn}
                          onClick={() => {
                            setSelectedId(p.id);
                            setShow(true);
                          }}
                        >
                          Remark
                        </button>
                        

                        
                      )} */}
{/* {admin?.role === "admin" && (
  <button
    style={btn}
    onClick={() => {
      setVerifyId(p.id);
      setShowVerify(true);
    }}
  >
    verify
  </button> */}
  {/* {admin?.role === "admin" && (
  p.status === "completed" ? (
    <button
      style={btn}
      onClick={() => {
        // invoice button action
      }}
    >
      Invoice
    </button>
  ) : (
    <button
      style={btn}
      onClick={() => {
        setVerifyId(p.id);
        setShowVerify(true);
      }}
    >
      Verify
    </button>
  )
)} */}
{admin?.role === "admin" && (
  p.status === "completed" ? (
    <button
      style={btn}
      onClick={() => {
        navigate("/admin/invoice-form", {
          state: { data: p }
        });
      }}
    >
      Invoice
    </button>
  ) : (
    <button
      style={btn}
      onClick={() => {
        setVerifyId(p.id);
        setShowVerify(true);
      }}
    >
      Verify
    </button>
  )
)}        
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {showVerify && (
  <div style={overlay}>
    <div style={modal}>
      <button style={closeBtn} onClick={() => setShowVerify(false)}>
        ×
      </button>

      <h4>Verify Project</h4>

      <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        
        <button
          style={{ ...submitBtn, width: "50%", background: "#D4c2BB",color:"#6c4636" }}
          onClick={async () => {
            try {
              await axios.put(
                `https://api.d2associates.in/project/resubmit/${verifyId}`
              );

              toast.success("Resubmitted");
              setShowVerify(false);
              fetchData();
            } catch (err) {
              toast.error("Error in resubmit");
            }
          }}
        >
          Resubmit
        </button>

        <button
          style={{ ...submitBtn, width: "50%", background: "#6c4636" }}
          onClick={async () => {
            try {
              await axios.put(
                `https://api.d2associates.in/project/complete/${verifyId}`
              );

              toast.success("Completed");
              setShowVerify(false);
              fetchData();
            } catch (err) {
              toast.error("Error in complete");
            }
          }}
        >
          Complete
        </button>

      </div>
    </div>
  </div>
)}
      {showPayment && (
  <div style={overlay}>
    <div style={modal}>
      <button style={closeBtn} onClick={() => setShowPayment(false)}>×</button>

      <h4>Receive Payment</h4>
<br />
      <p><b>Project:</b> {selectedProject?.project_name}</p>
      <p><b>Total Amount:</b> ₹ {totalAmount}</p>
<p>
  <b>Total Paid:</b> ₹{" "}
  {payData.reduce((total, item) => total + Number(item.amount), 0)}
</p>   

<br />
<p className="text-danger">
  <b>Pending:</b> ₹{" "}
  {totalAmount - payData.reduce((total, item) => total + Number(item.amount), 0)}
</p>
      <input
        type="number"
        placeholder="Enter Amount"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        style={{ width: "100%", marginTop: "10px", padding: "8px" }}
      />

      <input
        type="datetime-local"
        value={paymentDate}
        onChange={(e) => setPaymentDate(e.target.value)}
        style={{ width: "100%", marginTop: "10px", padding: "8px" }}
      />

      <button className="mt-4 py-2" style={submitBtn} onClick={handlePaymentSubmit}>
        Submit Now
      </button>

             <button className="btn btn-secondary w-100 mt-3" onClick={() => setShowPayHistory(true)}>
        View Report
      </button>

    </div>
  </div>
)}



{showPayHistory && (
   <div style={overlay}>
          <div style={modal}>

 <button style={closeBtn} onClick={() => setShowPayHistory(false)}>×</button>

      <h4>Payment Report</h4>

<br />
<div className="table-responsive">
<table className="w-100">

<thead className="bg-dark text-light">
<th className="p-2">S No</th>
<th className="p-2">Date</th>
<th className="p-2">Amount</th>
</thead>

<tbody>
  {payData.map((item, index) => (
    <tr key={index}>
      <td className="px-2 py-3 border-bottom">{index + 1}</td>
      <td className="px-2 py-3 border-bottom">₹ {item.amount}</td>
<td className="px-2 py-3 border-bottom">
  {new Date(item.date_time).toLocaleString("en-IN", {
    
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })}
</td>    </tr>
  ))}
</tbody>


</table>

  </div>


          </div>
          </div>
)}

      {show && (
        <div style={overlay}>
          <div style={modal}>
            <button style={closeBtn} onClick={() => setShow(false)}>×</button>
            <h4>Add Remark</h4>

            <textarea
              style={textarea}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
            <input
  type="file"
  accept=".pdf,.doc,.docx,.jpg,.png"
  onChange={(e) => setReportFile(e.target.files[0])}
  style={{ marginTop: "10px" }}
/>

           {/* <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
  <button style={submitBtn} onClick={handleReview}>
    Submit
  </button>

  <button style={submitBtn} onClick={handleReport}>
    Report
  </button>
</div> */}

<div style={{ marginTop: "10px" }}>
  <button style={submitBtn} onClick={handleReview}>
    Submit
  </button>
</div>
          </div>
        </div>
      )}
      {viewData && (
  <div style={detailCard}>

    <div className="d-flex justify-content-between">
    <h3 style={modalTitle}>Property Inspection Full Report</h3>
    <span className="fs-3" onClick={() => setViewData(false)}>x</span>
</div>

    <Section title="Owner Details">
      <p>Name: {viewData.owner_name}</p>
      <p>Father: {viewData.owner_father}</p>
      <p>Contact: {viewData.owner_contact}</p>
      <p>Address: {viewData.owner_address}</p>
    </Section>


    <Section title="Borrower Details">
      <p>Name: {viewData.borrower_name}</p>
      <p>Father: {viewData.borrower_father}</p>
      <p>Contact: {viewData.borrower_contact}</p>
      <p>Address: {viewData.borrower_address}</p>
    </Section>


    <Section title="Location">
      <p>Latitude: {viewData.latitude}</p>
      <p>Longitude: {viewData.longitude}</p>
    </Section>


    <Section title="Property Details">
      <p>Sale Deed: {viewData.sale_deed_no}</p>
      <p>Registration: {viewData.registration_date}</p>
      <p>Amount: {viewData.purchase_amount}</p>
      <p>Locality Price: {viewData.locality_price}</p>
      <p>Comment: {viewData.property_comment}</p>
    </Section>


    <Section title="Land Details">
      <p>Khata: {viewData.khata_no}</p>
      <p>Plot: {viewData.plot_no}</p>
      <p>Village: {viewData.village}</p>
      <p>Tahasil: {viewData.tahasil}</p>
      <p>Thana: {viewData.thana}</p>
      <p>District: {viewData.district}</p>
      <p>Postal: {viewData.postal_address}</p>
    </Section>


    <Section title="Area">
      <p>Acre: {viewData.land_acre}</p>
      <p>Sqft: {viewData.land_sqft}</p>
    </Section>


    <Section title="Boundary">
      <p>East: {viewData.east}</p>
      <p>West: {viewData.west}</p>
      <p>North: {viewData.north}</p>
      <p>South: {viewData.south}</p>
    </Section>


    <Section title="Road">
      <p>Width: {viewData.road_width}</p>
      <p>Type: {viewData.road_type}</p>
      <p>Sewerage: {viewData.sewerage ? "Yes" : "No"}</p>
      <p>Electricity: {viewData.electricity ? "Yes" : "No"}</p>
    </Section>


    <Section title="Building">
      <p>Floors: {viewData.floors}</p>
      <p>Structure: {viewData.structure_type}</p>
      <p>Flooring: {viewData.flooring}</p>
      <p>Interior: {viewData.interior}</p>
      <p>Design: {viewData.designing}</p>
      <p>Builtup: {viewData.builtup_area}</p>
      <p>Year: {viewData.construction_year}</p>
    </Section>


    <Section title="Approval">
      <p>Status: {viewData.approval_status}</p>
      <p>Authority: {viewData.approving_authority}</p>
      <p>Letter: {viewData.approval_letter}</p>
      <p>Date: {viewData.approval_date}</p>
      <p>FAR: {viewData.far}</p>
    </Section>

  
    <Section title="Nearby">
      <p>Landmark: {viewData.landmark}</p>
      <p>School: {viewData.school_distance}</p>
      <p>Hospital: {viewData.hospital_distance}</p>
      <p>Park: {viewData.park_distance}</p>
    </Section>

   
    <Section title="Final Remark">
      <p>{viewData.remark}</p>
    </Section>

{/*   
    <Section title="Site Images">
  <div style={imageWrap}>
    {(() => {
      if (!viewData.site_images) return <span>No Images</span>;

      let imgs = [];

      try {
        imgs = JSON.parse(viewData.site_images);
      } catch {
        console.log("Bad JSON:", viewData.site_images);
        return <span>Invalid Image Data</span>;
      }

      if (!Array.isArray(imgs)) return <span>No Images</span>;

      return imgs.length > 0 ? (
        imgs.map((img, i) => (
          <img
            key={i}
            src={`https://api.d2associates.in//dUploads/${img}`}
            style={imageStyle}
            onError={(e) => {
              console.log("Image :", img);
              e.target.style.display = "none";
            }}
          />
        ))
      ) : (
        <span>No Images</span>
      );
    })()}
  </div>
</Section> */}
<Section title="Site Images">

  {(() => {

    if (!viewData.site_images)
      return <span>No Images</span>;

    let imgs = [];

    try {

      imgs = JSON.parse(
        viewData.site_images
      );

    } catch {

      return (
        <span>Invalid Image Data</span>
      );

    }

    if (!Array.isArray(imgs))
      return <span>No Images</span>;

    return (
      <>
      <button
  style={{
    ...btn,
    marginBottom: "10px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  }}
  onClick={() => downloadAllImages(imgs)}
>
  <FaDownload />
  Download All Images
</button>
{/* 
        <button
          style={{
            ...btn,
            marginBottom: "10px",
          }}

          onClick={() =>
            downloadAllImages(imgs)
          }
        >
          Download All Images
        </button> */}

        <div style={imageWrap}>

          {imgs.map((img, i) => (

            <img
              key={i}

              src={`https://api.d2associates.in/dUploads/${img}`}

              style={imageStyle}

              onError={(e) => {
                e.target.style.display =
                  "none";
              }}
            />

          ))}

        </div>

      </>
    );

  })()}

</Section>

    {/* <Section title="Documents">
  {(() => {
    if (!viewData.documents) return <span>No Documents</span>;

    let docs = [];

    try {
      docs = JSON.parse(viewData.documents);
    } catch {
      return <span>Invalid Document Data</span>;
    }

    if (!Array.isArray(docs)) return <span>No Documents</span>;

    return docs.length > 0 ? (
      docs.map((doc, i) => (
        <a
          key={i}
          href={`https://api.d2associates.in//dUploads/${doc}`}
          target="_blank"
          rel="noreferrer"
          style={docLink}
        >
           View Document {i + 1}
        </a>
      ))
    ) : (
      <span>No Documents</span>
    );
  })()}
</Section> */}
<Section title="Documents">
  {(() => {

    if (!viewData.documents)
      return <span>No Documents</span>;

    let docs = [];

    try {

      docs = JSON.parse(
        viewData.documents
      );

    } catch {

      return (
        <span>Invalid Document Data</span>
      );

    }

    if (!Array.isArray(docs))
      return <span>No Documents</span>;

    return docs.length > 0 ? (

      <div
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          marginTop: "10px"
        }}
      >

        {docs.map((doc, i) => {

          const fileUrl =
            `https://api.d2associates.in/dUploads/${doc}`;

          const isImage =
            /\.(jpg|jpeg|png|gif|webp)$/i.test(doc);

          return (

            <div key={i}>

              {isImage ? (

                <img
                  src={fileUrl}
                  alt={`doc-${i}`}
                  style={{
                    width: "120px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    cursor: "pointer",
                    border: "1px solid #ddd"
                  }}
                  onClick={() =>
                    window.open(
                      fileUrl,
                      "_blank"
                    )
                  }
                />

              ) : (

                <a
                  href={fileUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "inline-block",
                    padding: "10px",
                    background: "#D4C2BB",
                    color: "#7D4B3C",
                    borderRadius: "6px",
                    textDecoration: "none"
                  }}
                >
                  View Document {i + 1}
                </a>

              )}

            </div>

          );

        })}

      </div>

    ) : (

      <span>No Documents</span>

    );

  })()}
</Section>
  
  </div>
)}
<ToastContainer position="top-center" autoClose={2000} />

      </div>
  );
};

export default Manageprojects;

const page = { padding: "20px", background: "#f5f7fb", minHeight: "100vh" };
const heading = { marginBottom: "15px", color: "#333" };
const card = { background: "#fff", borderRadius: "10px", padding: "15px" };
// const tableWrapper = { width: "100%", overflowX: "auto" };
const tableWrapper = { 
  width: "100%", 
  overflowX: "auto",
  WebkitOverflowScrolling: "touch"
};
const table = { width: "100%", borderCollapse: "collapse" };
const thead = { background: "#D4C2BB" };
const th = { padding: "12px" };
const tr = { borderBottom: "1px solid #eee" };
const td = { padding: "10px" };

const nameCell = { display: "flex", gap: "10px" };
// const avatar = {
//   width: "30px", height: "30px", borderRadius: "50%",
//   background: "#D4C2BB", display: "flex", alignItems: "center", justifyContent: "center"
// };

const avatar = {
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  background: "#D4C2BB",
  color: "#7D4B3C",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
};


const status = {
  padding: "4px 8px", borderRadius: "6px", color: "#fff", fontSize: "12px"
};

const btn = { padding: "6px 12px", background: "#6c4636", color: "#fff", border: "none", borderRadius: "6px" };
const viewBtn = { padding: "6px 14px", background: "#D4c2BB", color: "#7D4B3c", border: "none", borderRadius: "6px" };

const overlay = {
  position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
  background: "rgba(0,0,0,0.3)", display: "flex", justifyContent: "center", alignItems: "center"
};

//  const modal = { 
//   background: "#fff", 
//   padding: "20px", 
//   borderRadius: "10px", 
//   width: "520px",
//   position: "relative"  
// };
const modal = { 
  background: "#fff", 
  padding: "20px", 
  borderRadius: "10px", 
  width: "90%",
  maxWidth: "520px",
  maxHeight: "90vh",
  overflowY: "auto",
  position: "relative"  
};
// const closeBtn = { position: "absolute", right: "10px", top: "5px", border: "none", background: "transparent", cursor: "pointer" };
const closeBtn = {
  position: "absolute",
  right: "10px",
  top: "10px",
  border: "none",
  background: "#D4C2BB",
  color: "#000",
  fontSize: "18px",
  width: "28px",
  height: "28px",
  borderRadius: "50%",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

const textarea = { width: "100%", height: "80px", marginTop: "10px" };

const submitBtn = {
  marginTop: "10px", padding: "6px 12px", background: "#6c4636",
  color: "#fff", border: "none", borderRadius: "6px", width: "20%"
};


const detailCard = {
  background: "#fff",
  marginTop: "20px",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
};

const modalTitle = { fontSize: "18px", fontWeight: "600" };

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: "10px",
  marginTop: "10px"
};

const detailBox = {
  background: "#f9f9f9",
  padding: "10px",
  borderRadius: "6px",
  display: "flex",
  justifyContent: "space-between"
};

const imageWrap = {
  display: "flex",
  gap: "10px",
  flexWrap: "wrap",
  marginTop: "10px"
};

const imageStyle = {
  width: "100px",
  height: "80px",
  objectFit: "cover",
  borderRadius: "6px"
};

const docLink = {
  display: "block",
  color: "#007bff",
  marginTop: "5px"
};
const Section = ({ title, children }) => (
  <div style={{
    marginTop: "15px",
    padding: "10px",
    background: "#f9f9f9",
    borderRadius: "6px"
  }}>
    <h4 style={{ marginBottom: "5px" }}>{title}</h4>
    {children}
  </div>
);